var customerModelService = function (apiService, $q, VehicleService, transportationOptionsService, VALIDATION,
    ssWidgetService, mobileCheckInService, apiConstants) {

    var CustomerModel = function () {
        this._data = {};
    };

    CustomerModel.getTypedValue = function (type, array) {
        var values = array.filter(function (el) {
            return el.type == type;
        });
        return values.length ? values[0] : {};
    };

    CustomerModel.getCustomerDefaultPhone = function (customer) {
        if (!customer || !customer.phones) {
            return undefined;
        }
        return CustomerModel.getTypedValue('default', customer.phones).number;
    };

    CustomerModel.getCustomerFullName = function (customer) {
        if (!customer) {
            return undefined;
        }
        return customer.firstName + ' ' + customer.lastName;
    };

    CustomerModel.getCustomerDefaultEmail = function (customer) {
        if (!customer || !customer.emails) {
            return undefined;
        }
        return CustomerModel.getTypedValue('default', customer.emails).email;
    };

    CustomerModel.prototype.resetModel = function () {
        this._data = {};
        var currentVehicle = this.getCurrentVehicle();
        if (currentVehicle) {
            currentVehicle.setTelematicsData({});
        }
    };

    CustomerModel.prototype.setDataProperty = function (propertyName, propertyValue) {
        this._data[propertyName] = propertyValue;
        return this;
    };

    CustomerModel.prototype.getDataProperty = function (propertyName) {
        return this._data[propertyName];
    };

    CustomerModel.prototype.isGMDealer = function () {
        if (typeof this.getDataProperty('isGMDealer') === 'undefined') {
            var dealerMainManufacturer = this.getDealerMainManufacturer();
            if (dealerMainManufacturer && dealerMainManufacturer.oemName) {
                this.setDataProperty('isGMDealer', /(?:^|[^a-z])GM(?:$|[^a-z])/i.test(dealerMainManufacturer.oemName));
            } else {
                this.setDataProperty('isGMDealer', false);
            }
        }
        return this.getDataProperty('isGMDealer');
    };

    CustomerModel.prototype.isCadillacMake = function () {
        var vehicle = this.getCurrentVehicle();
        if (vehicle && vehicle.make && vehicle.make.name) {
            return vehicle.make.name.toUpperCase() === 'CADILLAC';
        }
        return false;
    };

    CustomerModel.prototype.isPickupAndDeliveryWagoneerModel = function () {
        var vehicle = this.getCurrentVehicle();
        if (vehicle && vehicle.make && vehicle.make.name && vehicle.model && vehicle.model.name && vehicle.year && vehicle.year.name) {
            return (((/^(?:.*)JEEP(?:.*)$/i.test(vehicle.make.name)) // check that make is Jeep (case insensitive)
                && (/^(?:.*)WAGONEER(?:.*)$/i.test(vehicle.model.name)) // check that model contains Wagoneer (case insensitive)
                && (parseInt(vehicle.year.name) >= 2022)) // check that year is 2022 or later
                || ((/^(?:.*)FIAT(?:.*)$/i.test(vehicle.make.name)) // check that make is Fiat (case insensitive)
                && (/^(?:.*)500E(?:.*)$/i.test(vehicle.model.name)) // check that model contains 500e (case insensitive)
                && (parseInt(vehicle.year.name) >= 2024))); // check that year is 2024 or later
        }
        return false;
    };

    CustomerModel.prototype.getCustomer = function () {
        return this.getDataProperty('customer');
    };

    CustomerModel.prototype.setCurrentVehicle = function (vehicle) {
        return this.setDataProperty('currentVehicle', vehicle);
    };

    CustomerModel.prototype.getCurrentVehicle = function () {
        return this.getDataProperty('currentVehicle');
    };

    CustomerModel.prototype.extendCustomer = function (customer) {
        return angular.extend(customer, {
            getDefaultPhone: (function (currentCustomer) {
                return function () {
                    return CustomerModel.getCustomerDefaultPhone(currentCustomer);
                };
            })(customer),
            getDefaultEmail: (function (currentCustomer) {
                return function () {
                    return CustomerModel.getCustomerDefaultEmail(currentCustomer);
                };
            })(customer),
            getFullName: (function (currentCustomer) {
                return function () {
                    return CustomerModel.getCustomerFullName(currentCustomer);
                };
            })(customer)
        });
    };

    CustomerModel.prototype.setCustomer = function (customer, verified) {
        if (customer && verified) this.setDataProperty('customerVerified', { customerId: customer.id });
        if (customer && customer.id) {
            const isDFXCustomer = customer.id.indexOf(':dfx:') > 0 && parseInt(customer.id.split(":").slice(-1)[0]) > 0;
            const nrActionName = isDFXCustomer ? 'DFX_Customer_Chosen' : 'DMS_Customer_Chosen';
            parent.postMessage({action: 'nrPageAction', name: nrActionName}, "*");
        }
        return this.setDataProperty('customer', customer ? this.extendCustomer(customer) : undefined);
    };

    CustomerModel.prototype.getVehicles = function () {
        return this.getDataProperty('vehicles');
    };

    CustomerModel.prototype.setSearchParameter = function (value) {
        if (VALIDATION.REGEXP_PHONE_NUMBER.test(value)) {
            value = value.replace(/\D+/g, '');
        }
        return this.setDataProperty('searchParameter', value);
    };

    CustomerModel.prototype.setCustomerConcernsServices = function (value) {
        // if (!(value instanceof Array)) {
        //     return [];
        // }
        // value.forEach(function (el) {
        //     el.selected = el.required || el.preselected || el.selected;
        // });
        return this.setDataProperty('customerConcernsServices', value || []);
    };

    CustomerModel.prototype.getCustomerConcernsServices = function () {
        return this.getDataProperty('customerConcernsServices') || [];
    };

    CustomerModel.prototype.setVehicleAlerts = function (value) {
        return this.setDataProperty('vehicleAlerts', value || []);
    };

    CustomerModel.prototype.getVehicleAlerts = function () {
        return this.getDataProperty('vehicleAlerts') || [];
    };

    CustomerModel.prototype.areVehicleAlertsLoaded = function () {
        return this.getDataProperty('vehicleAlerts') != undefined;
    };
    CustomerModel.prototype.areProtectionPlansLoaded = function () {
        return this.getDataProperty('protectionPlans') != undefined;
    };
    CustomerModel.prototype.setFactoryRequiredServices = function (value, force) {
        _.forEach(value, function (el) {
            el.selected = window.appSettings.displayFrsPreselected && !force || el.selected;
            el.required = window.appSettings.displayFrsPreselected && !window.appSettings.allowDeclineFrsPreselected;
        });
        return this.setDataProperty('factoryRequiredServices', value || []);
    };

    CustomerModel.prototype.getFactoryRequiredServices = function () {
        return this.getDataProperty('factoryRequiredServices') || [];
    };

    CustomerModel.prototype.setDealerRecommendedServices = function (value, force) {
        _.forEach(value, function (el) {
            el.selected = window.appSettings.displayDrsPreselected && el.intervalRecommended && !force || el.selected;
            el.required = window.appSettings.displayDrsPreselected && el.intervalRecommended && !window.appSettings.allowDeclineDrsPreselected;
        });
        return this.setDataProperty('dealerRecommendedServices', value || []);
    };

    CustomerModel.prototype.getDealerRecommendedServices = function () {
        return this.getDataProperty('dealerRecommendedServices');
    };

    CustomerModel.prototype.setCurrentAppointment = function (value) {
        return this.setDataProperty('currentAppointment', value);
    };
    CustomerModel.prototype.getCurrentAppointment = function () {
        return this.getDataProperty('currentAppointment');
    };

    CustomerModel.prototype.setExistingAppointments = function (value) {
        if (value) {
            var appointment = value.map(function (appointment) {
                if (appointment.transportationOption) {
                    transportationOptionsService.handleTO(appointment.transportationOption, this.isGMDealer(), this.isCadillacMake());
                }
                return appointment;
            }.bind(this))
        }
        return this.setDataProperty('existingAppointments', appointment);
    };

    CustomerModel.prototype.getExistingAppointments = function () {
        return this.getDataProperty('existingAppointments');
    };

    CustomerModel.prototype.setVehicles = function (vehicles) {
        this.setDataProperty('vehicles', []);
        vehicles.forEach(function (el) {
            this.getVehicles().push(VehicleService.extend(el));
        }.bind(this));
        return this;
    };

    CustomerModel.prototype.isCustomerVerified = function () {
        if (!this.getDataProperty('customerVerified'))
            return false;
        else {
            return this.getDataProperty('customerVerified').customerId == this.getCustomer().id;
        }
    };

    // isNewCustomer
    //
    // @param {object} - customer to check
    //
    // @return {Boolean} - true if customer is new
    //
    // @description
    // Method checks if customer was got from API or
    // it is a new one
    CustomerModel.prototype.isNewCustomer = function (customer) {
        return customer ? !customer.existingCustomer : true;
    };

    CustomerModel.prototype.resolveCustomersData = function (customers, searchParameter) {
        return $q.all(customers.map(function (el) {
            el = this.extendCustomer(el);
            el.existingCustomer = true;
            var deferred = $q.defer();
            $q.all([
                el.getVehicles(searchParameter),
                el.getAppointments()
            ]).then(function (resultsSet) {
                el.appointments = resultsSet[1]
                if (resultsSet[0].length == 0) {
                    el.vehicles = [];
                    deferred.resolve(el);
                    return $q.reject();
                } else {
                    return $q.all(resultsSet[0].map(function (vehicle) {
                        return vehicle.getVehicle();
                    }));
                }
            }).then(function (vehicles) {
                el.vehicles = vehicles.map(function (currentVehicle) {
                    return VehicleService.extend(currentVehicle);
                });
                deferred.resolve(el);
            }).catch(function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }.bind(this)));
    };

    CustomerModel.prototype.resolveCustomer = function (searchString) {
        var deferred = $q.defer(),
            customersPreview = undefined;

        // get catalog
        apiService.getCatalog()
            .then(function (catalog) {
                //get customers
                return catalog.findCustomers(searchString);
            }.bind(this)).then(function (customers) {
                if (!customers.length) {
                    return $q.reject('Customer not found.');
                } else {
                    // precache the customer array to have possibilities
                    // to get the found tipe property for every customer id
                    customersPreview = customers;
                    return $q.all(customers.map(function (el) {
                        return el.getCustomer();
                    }));
                }
            }.bind(this)).then(function (customers) {
                // add fount type value from previously saved array
                customers = customers.map(function (currentCustomer) {
                    var filtered = customersPreview.filter(function (el) {
                        return el.id == currentCustomer.id;
                    });
                    if (filtered.length) {
                        currentCustomer.foundType = filtered[0].foundType;
                    }
                    return currentCustomer;
                });
                // resolve additional customer data like existing appointments and vehicles
                return this.resolveCustomersData(customers, searchString);
            }.bind(this)).then(function (customersData) {
                deferred.resolve(customersData);
            }.bind(this)).catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };
    /*
     Searches customer by given search string
     */
    CustomerModel.prototype.searchCustomer = function (searchString, notClean) {
        var deferred = $q.defer();
        if (!notClean) {
            this.setCustomer(undefined);
            this.setDataProperty('customerVerified', null);
            this.setVehicles([]);
        }

        this.setSearchParameter(searchString);
        apiService.getCatalog().then(function (catalog) {
            return catalog.findCustomers(searchString);
        }).then(function (customers) {
            return $q.all(customers.map(function (customer) {
                var p = $q.defer(), currentCustomer = customer;
                if (customer.foundType == "byVin") {
                    customer.vehicles = [customer.vehicle];
                    p.resolve(currentCustomer);
                } else {
                    customer.getVehicles(searchString).then(function (vehicles) {
                        currentCustomer.vehicles = vehicles;
                        p.resolve(currentCustomer);
                    }).catch(function (err) {
                        p.reject(err);
                    });
                }
                return p.promise;
            }));
        }).then(function (customers) {
            deferred.resolve(customers);
        }).catch(function (err) {
            deferred.reject(err)
        });
        return deferred.promise;
    };

    CustomerModel.prototype.resolveCustomerConcernsServices = function (vehicle, force) {

        var deferred = $q.defer();
        var result = this.getCustomerConcernsServices();
        if (result.length && !force) {
            deferred.resolve(result);
            return deferred.promise;
        }

        var promise;
        if (vehicle.getDriveTrain() && vehicle.getDriveTrain().resolveCustomerConcernsServices) {
            promise = vehicle.getDriveTrain().resolveCustomerConcernsServices();
        } else {
            promise = vehicle.model.resolveModel().then(function (model) {
                return model.resolveCustomerConcernsServices();
            });
        }

        return promise
            .then(function (services) {
                // NO--COMMIT
                // var fakeMCService = _.cloneDeep(_.last(services));
                // fakeMCService.id = 99999;
                // fakeMCService.name = "Mobile Checkin Fake Service";
                // fakeMCService.selected = true;
                // _.set(_.find(fakeMCService.links, {rel: 'http://api.dealer-fx.com/docs/rels/maintenance-service-category'}),
                //     'href', 'http://oss.dfx.local:8080/catalog/maintenance-service-categories/60');
                // services.unshift(fakeMCService);
                return this.resolveSurveyServices(services);
            }.bind(this))
            .then(function (services) {
                services.filter(function (s) {
                    return mobileCheckInService.isMobileCheckInService(s);
                }).forEach(function (s) { s.hideOnUi = true; });

                services.filter(function (s) {
                    return CustomerModel.removeCategoryOSSServices(s);
                }).forEach(function (s) { s.hideOnUi = true; });

                this.setCustomerConcernsServices(services);

                return services;
            }.bind(this))
    };

    CustomerModel.prototype.resolveSurveyServices = function (services) {
        if (!ssWidgetService.isEnabled()) return $q.resolve(services);
        return $q.all(services.map(function (s) { return ssWidgetService.getSurveyAssociatedToService(s.id) }.bind(this)))
            .then(function (r) { return r.map(el => el[0]) })
            .then(function (r) { return r.filter(el => !!el) })
            .then(function (r) {
                r.forEach(el => {
                    services.find(s => s.id.toString() === el.serviceId.toString()).survey = el;
                });
                return services;
            })
            .then(function (services) {
                return ssWidgetService.resolveAvailableSurveys()
                    .then(function () {
                        return services;
                    });
            });
    };

    CustomerModel.prototype.setRecallsUpdates = function (value) {
        //preselect recalls by default.
        _.forEach(value, function (el) {
            el.selected = window.appSettings.allowRecallsPreSelected || el.selected;
            el.required = window.appSettings.allowRecallsPreSelected && !window.appSettings.allowDeclineRecallsPreselected;
        });

        return this.setDataProperty('recalls', value);
    };

    CustomerModel.prototype.getRecallsUpdates = function () {
        return this.getDataProperty('recalls');
    };

    CustomerModel.prototype.getMergedRecalls = function () {
        var appointment = this.getCurrentAppointment();
        var recalls = this.getRecallsUpdates();
        if (appointment && appointment?.services?.recalls) {
            _.forEach(appointment.services.recalls, (s1) => {
                const s2 = _.find(recalls, { id: s1.id });
                if (s2) {
                    if (!s1.campaignNumber) s1.campaignNumber = s2.campaignNumber;
                    if (!s1.longDescription) s1.longDescription = s2.longDescription;
                }
            });
            recalls = _.unionBy(appointment.services.recalls, recalls, 'id');
        }
        return recalls || [];
    };

    CustomerModel.prototype.resolveRecallsUpdates = function () {
        var vehicle = this.getCurrentVehicle();
        return vehicle.resolveRecalls().then(function (result) {
            this.setRecallsUpdates(result);
            return result;
        }.bind(this));
    };

    // get amoumt of selected recalls
    CustomerModel.prototype.getAmountRecallsUpdates = function () {
        return _.size(_.filter(this.getMergedRecalls(), { 'selected': true }));
    }

    // Set Protection Plans
    CustomerModel.prototype.setProtectionPlansUpdates = function (value) {
        //preselect recalls by default.
        // _.forEach(value, function (el) {
        //     el.selected = window.appSettings.allowRecallsPreSelected || el.selected;
        //     el.required = window.appSettings.allowRecallsPreSelected && !window.appSettings.allowDeclineRecallsPreselected;
        // });
        
        return this.setDataProperty('protectionPlans', value);
    };

    CustomerModel.prototype.getProtectionPlansUpdates = function () {
        return this.getDataProperty('protectionPlans');
    };

    CustomerModel.prototype.getMergedProtectionPlans = function () {
        if (!window.appSettings.enableProtectionPlans) {
            return [];
        }

        var appointment = this.getCurrentAppointment();
        var protectionPlans = this.getProtectionPlansUpdates();
        if (appointment && appointment?.services?.protectionPlans) {
            _.forEach(appointment.services.protectionPlans, (s1) => {
                const s2 = _.find(protectionPlans, { id: s1.id });
                if (s2) {
                    if (!s1.PlanCode) s1.PlanCode = s2.PlanCode;
                    if (!s1.longDescription) s1.SubType = s2.SubType;
                }
            });
            protectionPlans = _.unionBy(appointment.services.protectionPlans, protectionPlans, 'id');
        }
        return protectionPlans || [];
    };

    CustomerModel.prototype.resolveProtectionPlansUpdates = function () {
        if (window.appSettings.enableProtectionPlans) {
            var vehicle = this.getCurrentVehicle();
            const apiServiceCatalog = apiService.getCatalog();
            return apiServiceCatalog.then(function (catalog) {      
            
            if (vehicle != undefined && vehicle.vin != undefined) {
                    var protectionPlans = catalog.getProtectionPlans(vehicle.vin);
                    return protectionPlans;
                } 
                else {
                    return [];
                }
            
            }.bind(this));
        } else {
            return [];
        }
    };


    // get amoumt of selected alerts
    CustomerModel.prototype.getAmountAlertsUpdates = function () {
        return _.size(_.filter(this.getMergedAlerts(), { 'selected': true }));
    }

    // get amoumt of selected customer concerns services
    //
    // @return {Object} function result
    //      amount - amount of selected services
    //      price - total price of selected services
    CustomerModel.prototype.getAmountSelectedCustomerConcernsServices = function () {
        var customerConcernsServices = this.getCustomerConcernsServices(),
            amount = 0,
            price = 0;
        angular.forEach(customerConcernsServices, function (el) {
            if (el.selected) {
                amount += 1,
                    price += parseFloat(el.price || 0);
            }
        });
        return {
            amount: amount,
            price: price
        };
    };

    CustomerModel.prototype.resolveAlertsUpdates = function () {
        var vehicle = this.getCurrentVehicle();
        var telematicsWarningList = [];

        const apiServiceCatalog = apiService.getCatalog();
        
        if (window.appSettings.telematicsMileageEnabled || window.appSettings.ossShowVehicleAlerts) {
           return apiServiceCatalog
            .then(function (catalog) {
                var telematicsData = vehicle.getTelematicsData();
                //Only get telematics data if it's not already available
                if (telematicsData) {
                    return telematicsData;
                }
                return catalog.getVehicleTelematics(vehicle.vin);
            }.bind(this))
            .then(function (telematicsData) {
                if (telematicsData && telematicsData.warningList && !(telematicsData.warningList.length === 0)) {
                    vehicle.setTelematicsData(telematicsData);
                    telematicsWarningList = vehicle.getTelematicsData().warningList;
                    return apiServiceCatalog.then(function (catalog) {
                        return catalog.getAlertPlaceholders(vehicle.vin);
                    }.bind(this));
                }
                else {
                    return [];
                }
            }.bind(this))
            .then(function (placeholders) {
                var vehicleAlerts = [];
                var numAlerts = Math.min(telematicsWarningList.length, placeholders.length);

                for (let index = 0; index < numAlerts; index++) {
                    var alert = {}
                    alert.id = placeholders[index].Id;
                    alert.title = placeholders[index].Title;
                    alert.name = placeholders[index].Title;
                    alert.description = telematicsWarningList[index].title;
                    alert.code = telematicsWarningList[index].code;
                    alert.comment = alert.code + ' - ' + alert.description;
                    alert.selected = false;

                    vehicleAlerts.push(alert);
                }

                this.setVehicleAlerts(vehicleAlerts);

                return this.getVehicleAlerts();
            }.bind(this))
        }
        else {
            return [];
        }
    };

    // 37598: TMNA SmartPath - OS - Vehicle Alerts Rescheduling Workflow (SP7)
    // To get merged alerts (both selected and unselected)
    CustomerModel.prototype.getMergedAlerts = function () {
        var appointment = this.getCurrentAppointment();
        var alerts = this.getVehicleAlerts();

        if (appointment && appointment?.services?.alerts) {
            alerts = _.unionBy(appointment.services.alerts, alerts, 'id');
        }
        return alerts || [];
    };

    // get amount of selected customer factory required services
    //
    // @return {Object} function result
    //      amount - amount of selected services
    //      price - total price of selected services
    CustomerModel.prototype.getAmountSelectedFactoryRequiredServices = function () {
        var factoryRequiredServices = this.getFactoryRequiredServices(),
            amount = 0,
            price = 0,
            isServiceContractValid = this.isServiceContractValid(),
            getCurrentScheduledTime = this.getCurrentScheduledTime(),
            getServiceContract = this.getServiceContract();
        angular.forEach(factoryRequiredServices, function (el) {
            if (el.selected) {
                if ((el.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange && isServiceContractValid.IsContractOilValid) || (el.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion && isServiceContractValid.IsContractTireRotaionValid)) {
                    let serviceContractEndDate = moment.parseZone(getServiceContract.EndDate, moment.ISO_8601).format('YYYY-MM-DD');
                    let scheduledUnFormatedDateTime = getCurrentScheduledTime ? moment.parseZone(getCurrentScheduledTime.time, moment.ISO_8601).format('YYYY-MM-DD') : moment.parseZone(new Date(), moment.ISO_8601).format('YYYY-MM-DD');
                    if (Date.parse(serviceContractEndDate) >= Date.parse(scheduledUnFormatedDateTime)) {
                        el.price = 0;
                    }
                }
                amount += 1,
                    price += parseFloat(el.price || 0);
            }
        });
        return {
            amount: amount,
            price: price
        };
    };

    // get amount of selected other and dealer recommended services
    //
    // @return {Object} function result
    //      amount - amount of selected services
    //      price - total price of selected services
    CustomerModel.prototype.getAmountSelectedDealerRecommendedServices = function () {
        var dealerRecommendedServices = this.getDealerRecommendedServices(),
            amount = 0,
            price = 0;
        angular.forEach(dealerRecommendedServices, function (el) {
            if (el.selected) {
                amount += 1,
                    price += parseFloat(el.price || 0);
            }
        });
        return {
            amount: amount,
            price: price
        };
    };

    // get amount of all customer selected services and their total price
    //
    // @return {Object} function result
    //      amount - amount of selected services
    //      price - total price of selected services
    CustomerModel.prototype.getSelectedServicesAmount = function () {
        var concernsServicesAmount = this.getAmountSelectedCustomerConcernsServices(),
            factoryRequiredServicesAmount = this.getAmountSelectedFactoryRequiredServices(),
            dealerRecommendedServicesAmount = this.getAmountSelectedDealerRecommendedServices(),
            recallsUpdatesAmount = this.getAmountRecallsUpdates();
            vehicleAlertsAmount = this.getAmountAlertsUpdates();
        return {
            amount: concernsServicesAmount.amount + factoryRequiredServicesAmount.amount + dealerRecommendedServicesAmount.amount + recallsUpdatesAmount + vehicleAlertsAmount,
            price: Math.round((concernsServicesAmount.price + factoryRequiredServicesAmount.price + dealerRecommendedServicesAmount.price) * 100) / 100
        };
    };
    /**
     * getSelectedMaintenanceServices
     *
     * @return {Object} - selected maintenance services
     *   - factoryRequired - selected factory required services
     *   - customerConcerns - selected customer concerns
     *   - dealerRecommended - selected dealer recommended services
     *
     * @description
     * Method gets all selected by user services
     */
    CustomerModel.prototype.getSelectedMaintenanceServices = function () {
        return {
            factoryRequired: this.getFactoryRequiredServices().filter(function (service) {
                return service.selected;
            }),
            customerConcerns: this.getCustomerConcernsServices().filter(function (service) {
                return service.selected;
            }),
            dealerRecommended: this.getDealerRecommendedServices().filter(function (service) {
                return service.selected;
            }),
            recallsUpdates: _.filter(this.getMergedRecalls(), function (recall) {
                return recall.selected;
            }),
            vehicleAlerts: _.filter(this.getMergedAlerts(), function (alert) {
                return alert.selected;
            }),
            protectionPlans: _.filter(this.getMergedProtectionPlans(), function (protectionPlans) {
                return protectionPlans.selected;
            })
        };
    };
    /**
     * getMergedListOfServices
     *
     * @returns {Array<Object>} - list of selected by user services consist of
     *  - dealer recommended services (if enabled by settings)
     *  - customer concerns services (if enabled by settings)
     *  - factory required services
     *
     * @memberOf CustomerModel
     *
     * @description
     * Method creates list of services that was selected by user
     */
    CustomerModel.prototype.getMergedListOfServices = function () {
        var list = [];

        if (window.appSettings.displayFrsConfiguration) {
            list = list.concat(this.getFactoryRequiredServices().filter(function (service) {
                return service.selected;
            }));
        }
        if (window.appSettings.displayConcernsConfiguration) {
            list = list.concat(this.getCustomerConcernsServices().filter(function (service) {
                return service.selected;
            }));
        }
        if (window.appSettings.displayDrsConfiguration) {
            list = list.concat(this.getDealerRecommendedServices().filter(function (service) {
                return service.selected;
            }));
        }
        if (window.appSettings.enableRecalls) {
            list = list.concat(this.getMergedRecalls().filter(function (service) {
                return service.selected;
            }));
        }
        if (window.appSettings.ossShowVehicleAlerts) {
            list = list.concat(this.getMergedAlerts().filter(function (service) {
                return service.selected;
            }));
        }
        list = list.concat(this.getMergedProtectionPlans().filter(function (service) {
            return service.selected;
        }));
        return list;
    };

    /**
     * getOpCodes
     *
     * @returns {string} - string of opCodes from selected services consist of
     *  - dealer recommended services (if enabled by settings)
     *  - customer concerns services (if enabled by settings)
     *  - factory required services
     *  - recalls (if enabled by settings)
     *
     * @memberOf CustomerModel
     *
     * @description
     * Method collect opCodes from selected services for time-segments request
     */
    CustomerModel.prototype.getOpCodes = function () {
        if (!window.appSettings.opCodesBlockingEnabled) return '';
        var ss = this.getMergedListOfServices();
        var opCodes = _.chain(ss)
            .map(function (s) {
                // TODO: PBI-18903 ugly solution, refactor when a field with the right opcode will be added to the appointment recalls.
                var code = s.maintenanceKind === 'Recalls' ? s.comment.split(' ')[0] : s.opCode;
                return code;
            })
            .compact()
            .uniq()
            .join()
            .value();

        return opCodes;
    };

    /**
     * getConfirmationCode
     *
     * @returns {string} - appointment Confirmation Code or empty string
     * @memberOf CustomerModel
     * @description
     * Method get appointment confirmation code
     */
    CustomerModel.prototype.getConfirmationCode = function () {
        return this.getCurrentAppointment() ? this.getCurrentAppointment().confirmationCode : '';
    };


    //setCurrentAdviser
    //
    //@param {object} service adviser
    //
    //@return {object} just set service adviser
    //
    //@description
    //Sets the current adviser
    CustomerModel.prototype.setCurrentAdviser = function (value) {
        return this.setDataProperty('currentServiceAdviser', value).getDataProperty('currentServiceAdviser');
    };

    //getCurrentAdviser
    //
    //@return {object} current service adviser
    //
    //@description
    //Method gets current service adviser
    CustomerModel.prototype.getCurrentAdviser = function () {
        return this.getDataProperty('currentServiceAdviser');
    };

    CustomerModel.prototype.getCurrentDepartment = function () {
        return this.getDataProperty('currentDepartment');
    };
    CustomerModel.prototype.setCurrentDepartment = function (value) {
        this.setDataProperty('currentDepartment', value);
    };

    //setCurrentTransportationOption
    //
    //@param {object} transportation option
    //
    //@return {object} just set transportation option
    //
    //@description
    //Method sets selected item of avaliable transportation options
    CustomerModel.prototype.setCurrentTransportationOption = function (value, useTOHandler) {
        if (value && value.deliveryInfo) {
            this.setTransportationDeliveryAddress(value.deliveryInfo.deliveryAddress);
            this.setTransportationPickupAddress(value.deliveryInfo.pickupAddress);
        }
        return this
            .setDataProperty(
                'currentTransportationOption',
                (useTOHandler || typeof useTOHandler === 'undefined')
                    ? transportationOptionsService.handleTO(value, this.isGMDealer(), this.isCadillacMake())
                    : value
            )
            .getDataProperty('currentTransportationOption');
    };

    //getCurrentTransportationOption
    //
    //@return {object} current transportation option
    //
    //@description
    //Method gets current transportation option
    CustomerModel.prototype.getCurrentTransportationOption = function () {
        return this.getDataProperty('currentTransportationOption');
    };

    //setCurrentScheduledTime
    //
    //@param {string} current selected time
    //
    //@return {string} just sent time
    //
    //@description
    //Mehtod sets current selected time to schedule appointment
    CustomerModel.prototype.setCurrentScheduledTime = function (value) {
        return this.setDataProperty('currentTime', value).getDataProperty('currentTime');
    };

    //getCurrentScheduledTime
    //
    //@return {string} selected time
    //
    //@description
    //Method returns stored in the model shedule time of the appointment
    CustomerModel.prototype.getCurrentScheduledTime = function () {
        return this.getDataProperty('currentTime');
    };

    //setFoundCustomers
    //
    //@param {array} array of the customers
    //
    //@description
    //Set the customer into temporary storage
    CustomerModel.prototype.setFoundCustomers = function (value) {
        this.setDataProperty('foundCustomers', value);
    };

    //getFoundCustomers
    //
    //@return {array} array of the customers
    //
    //@description
    //Get the customers from temporary storage
    CustomerModel.prototype.getFoundCustomers = function (value) {
        return this.getDataProperty('foundCustomers');
    };

    CustomerModel.prototype.setConcernsDescription = function (value) {
        this.setDataProperty('concernsDescription', value);
    };

    CustomerModel.prototype.getConcernsDescription = function (value) {
        return this.getDataProperty('concernsDescription');
    };

    CustomerModel.prototype.setTransportationPickupAddress = function (value) {
        this.setDataProperty('transportationPickupAddress', value);
    };

    CustomerModel.prototype.getTransportationPickupAddress = function () {
        return this.getDataProperty('transportationPickupAddress');
    };

    CustomerModel.prototype.getTransportationDeliveryAddress = function () {
        return this.getDataProperty('transportationDeliveryAddress');
    };

    CustomerModel.prototype.setTransportationDeliveryAddress = function (value) {
        this.setDataProperty('transportationDeliveryAddress', value);
    };

    CustomerModel.prototype.getVehicleCreationData = function () {
        return this.getDataProperty('vehicleCreationData');
    };
    CustomerModel.prototype.setVehicleCreationData = function (value) {
        this.setDataProperty('vehicleCreationData', value);
    };

    CustomerModel.prototype.getSearchParameter = function () {
        return this.getDataProperty('searchParameter');
    };

    CustomerModel.prototype.getDealerMainManufacturer = function () {
        if (!this.getDataProperty('dealerMainManufacturer')) {
            // trying to get dealer main manufacturer from vehicle creation data
            var vehicleCreationData = this.getVehicleCreationData();
            if (vehicleCreationData && vehicleCreationData.manufacturers && vehicleCreationData.manufacturers.length) {
                var manufacturer = vehicleCreationData.manufacturers.filter(function (m) {
                    return m.main;
                })[0];
                this.setDataProperty('dealerMainManufacturer', manufacturer);
            }
        }
        return this.getDataProperty('dealerMainManufacturer');
    };
    CustomerModel.prototype.setDealerMainManufacturer = function (value) {
        this.setDataProperty('dealerMainManufacturer', value);
    };
    CustomerModel.prototype.resolveDealerMainManufacturer = function () {
        var deferred = $q.defer();
        var dealerMainManufacturer = this.getDealerMainManufacturer();
        if (!dealerMainManufacturer) {
            apiService.getCatalog()
                .then(function (catalog) {
                    return catalog.getManufacturers();
                })
                .then(function (manufacturers) {
                    if (manufacturers && manufacturers.length) {
                        var manufacturer = manufacturers.filter(function (m) {
                            return m.main;
                        })[0];
                        if (manufacturer) {
                            this.setDealerMainManufacturer(manufacturer);
                        }
                    }
                    deferred.resolve(this.getDealerMainManufacturer());
                }.bind(this))
                .catch(function (err) {
                    deferred.reject(err);
                });
        } else {
            deferred.resolve(dealerMainManufacturer);
        }
        return deferred.promise;
    };

    CustomerModel.prototype.isServiceContractValid = function () {
        var currentVehicle = this.getServiceContract();

        let contracts = {
            "IsContractOilValid": false,
            "IsContractTireRotaionValid": false
        };
        if (currentVehicle && this._data.currentVehicle.odometer) {
            var odometer = this._data.currentVehicle.odometer;
            //Condition to check if service contract enddate is greater or equal to current date and vehicle odometer reading is less than or equal to service contract odometer
            if (Date.parse(currentVehicle.EndDate) >= Date.parse(new Date()) && (parseInt(odometer) <= parseInt(currentVehicle.EndOdometer))) {
                parseInt(currentVehicle.OilChangesRemaining) > 0 ? contracts.IsContractOilValid = true : false;
                parseInt(currentVehicle.TireRotationRemaining) > 0 ? contracts.IsContractTireRotaionValid = true : false;
            }
        }
        return contracts;
    };

    CustomerModel.prototype.getServiceContract = function () {
        var currentVehicle = this.getCurrentVehicle();
        var oilAndTireRotationContracts = [];
        var odometerContracts = [];
        var endDateContracts = {};
        //Condition to check if service contracts is not null and odometer is greater than zero
        if (currentVehicle && currentVehicle.serviceContracts && currentVehicle.serviceContracts.length > 0 && this._data.currentVehicle.odometer) {
            var odometer = this._data.currentVehicle.odometer;
            oilAndTireRotationContracts = currentVehicle.serviceContracts.filter(x => parseInt(x.OilChangesRemaining) > 0 && parseInt(x.TireRotationRemaining) > 0);
            if (oilAndTireRotationContracts.length == 0)
                oilAndTireRotationContracts = currentVehicle.serviceContracts.filter(x => parseInt(x.OilChangesRemaining) > 0 || parseInt(x.TireRotationRemaining) > 0);
            if (oilAndTireRotationContracts.length == 0) return endDateContracts;
            odometerContracts = oilAndTireRotationContracts.filter(x => parseInt(odometer) <= parseInt(x.EndOdometer));
            if (odometerContracts.length == 0) return endDateContracts;
            endDateContracts = odometerContracts.sort((a, b) => Date.parse(a.EndDate) - Date.parse(b.EndDate))[odometerContracts.length - 1];
        }
        return endDateContracts;
    };

    // 40628: GM OSS - Hide GM OSS Service on Regular OSS
    var filteredServiceCategoryIds = window.appSettings.filteredServiceCategoryIds;

    CustomerModel.removeCategoryOSSServices = function (s) {
        const rel = 'http://api.dealer-fx.com/docs/rels/maintenance-service-category';
        try {
            var filteredServiceCategoryIdsList = filteredServiceCategoryIds.split(',');
            if (filteredServiceCategoryIdsList.includes(s.links.filter(function (l) { return l.rel === rel })[0].href.match(/\d+$/)[0])) {
                return true;
            }
        } catch (e) {
            return false;
        }
        return false;
    };

    return new CustomerModel();
};
customerModelService.$inject = ['apiService', '$q', 'VehicleService', 'transportationOptionsService', 'VALIDATION',
    'ssWidgetService', 'mobileCheckInService', 'ApiConstants'];

module.exports = customerModelService;
